import { useLocation } from "react-router-dom";
import AuthCallback from "@/pages/AuthCallback";

/**
 * Handles the Emergent Google OAuth session_id that comes back in the URL fragment.
 * Detection is done during render (not in useEffect) to avoid race conditions.
 */
export default function RootRouter({ children }) {
  const location = useLocation();
  if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return children;
}
